export const SearchResults = {
  transclude: true,

  bindings: {
    onUpdateParam: '&',
    order: '<',
    pagination: '<',
    type: '@',
  },

  template: `
    <header class="d-flex justify-content-between align-items-center py-2">
      <small class="py-3"
        ng-hide="$ctrl.pagination.total">
        No results found.
      </small>
      <small ng-show="$ctrl.pagination.total">
        {{ $ctrl.pagination.total || 0 }} {{ $ctrl.type }} found.
      </small>
      <search-order
        title="Sort by:"
        list="$ctrl.order"
        on-click="$ctrl.onUpdateParam({ key: 'order', value: value })"
        ng-show="$ctrl.pagination.total">
      </search-order>
    </header>
    <div class="search-results" ng-transclude></div>
    <pagination-row
      on-update-param="$ctrl.onUpdateParam({ key: key, value: value })"
      pagination="$ctrl.pagination">
    </pagination-row>
  `,
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchResults.js